// Ordered list of onboarding steps. The state machine lives in OnboardingScreen.
// Adding a new step: append here AND add the matching child component.

export const ONBOARDING_STEPS = [
  "welcome",
  "permissions",
  "connect",
  "device",
  "pairing",
  "complete"
] as const;

export type OnboardingStep = (typeof ONBOARDING_STEPS)[number];

export function stepIndex(step: OnboardingStep): number {
  return ONBOARDING_STEPS.indexOf(step);
}
